import { Card, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { RolesList, RolesConfigurationWarningIcon } from "../../../components";
import { useRolesValidation } from "src/http";

interface IProps {
  userGuid: string;
}

const UserRolesAgendaStep = (props: IProps) => {
  const { isEngagementValid, hasPrimaryRole } = useRolesValidation(props.userGuid);

  return (
    <Card>
      <CardHeader
        title={
          <Stack direction="row" spacing={0.25} sx={{
            alignItems: "center"
          }}>
            <Typography variant="h6">Roles</Typography>
            {(!isEngagementValid || !hasPrimaryRole) && (
              <RolesConfigurationWarningIcon
                userId={props.userGuid}
                isEngagementValid={isEngagementValid}
                hasPrimaryRole={hasPrimaryRole}
              />
            )}
          </Stack>
        }
      />
      <Divider />
      <RolesList userId={props.userGuid} />
    </Card>
  );
};

export { UserRolesAgendaStep };
